module.exports = __webpack_public_path__ + "static/assets/f5faf4a43486075fee09e866e7def14d.svg";